import { tryCatch } from '@wix/funnel-utils'
import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { FlowId } from '../../flowIds'
import { HeadlessFallback } from '../../Templates'

interface TemplatesFallbackProps {
  flowId: string
}

const handleStudioFallback = async () => {
  await tryCatch(() => markAsWixStudioAccount())
  window.open('https://manage.wix.com/studio/discover', '_self')
}

export const TemplatesFallback: FC<TemplatesFallbackProps> = ({ flowId }) => {
  if (flowId === FlowId.HEADLESS || flowId === FlowId.NEW_HEADLESS) {
    return <HeadlessFallback />
  }
  if (flowId === FlowId.STUDIO) {
    void handleStudioFallback()
  }
  return null
}
